// Deterministic mock EXIF derived from photo id — same id always yields the same values.
const CAMERAS = [
  "Sony α7R IV",
  "Canon EOS R5",
  "Nikon Z9",
  "Fujifilm X-T5",
  "Leica Q3",
  "Hasselblad X2D 100C",
  "Panasonic Lumix S5 II",
];
const LENSES = [
  "24-70mm f/2.8",
  "35mm f/1.4",
  "50mm f/1.2",
  "85mm f/1.4",
  "70-200mm f/2.8",
  "16-35mm f/2.8",
  "100mm Macro f/2.8",
];
const APERTURES = ["f/1.4", "f/1.8", "f/2.0", "f/2.8", "f/4.0", "f/5.6", "f/8.0"];
const SHUTTERS = ["1/60", "1/125", "1/250", "1/500", "1/1000", "1/2000", "1/4000"];
const ISOS = [100, 200, 400, 800, 1600, 3200];

function pick(arr, seed) {
  return arr[Math.abs(seed) % arr.length];
}

export function deterministicExif(id) {
  const n = Number(id) || 0;
  return {
    camera: pick(CAMERAS, n),
    lens: pick(LENSES, Math.floor(n / 7)),
    aperture: pick(APERTURES, Math.floor(n / 13)),
    shutter: pick(SHUTTERS, Math.floor(n / 17)),
    iso: pick(ISOS, Math.floor(n / 23)),
    focalLength: `${20 + (n % 180)}mm`,
  };
}

const STOPWORDS = new Set([
  "a","an","and","the","of","in","on","with","for","to","from","by","at","is","are",
  "this","that","these","those","photo","image","picture","view","stunning","beautiful",
  "spectacular","majestic","clear","day","up","its","near","over","under"
]);

export function tagsFromAlt(alt, max = 6) {
  if (!alt) return [];
  const words = alt
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, " ")
    .split(/\s+/)
    .filter((w) => w && !STOPWORDS.has(w) && w.length > 2);
  const seen = new Set();
  const out = [];
  for (const w of words) {
    if (!seen.has(w)) {
      seen.add(w);
      out.push(w);
    }
    if (out.length >= max) break;
  }
  return out;
}

export function megapixels(w, h) {
  if (!w || !h) return "—";
  return ((w * h) / 1_000_000).toFixed(1) + " MP";
}
